export default [
  {
    description: 'Notas de Versão',
    path: '/ferramentas/notas_versao',
    name: 'notas_versao',
    component: () => import('@/views/ferramentas/notas_versao/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]

